export default __webpack_public_path__ + "static/media/Affordable.61fc6e79.svg";